import React from 'react';
import { connect } from 'react-redux'

// Components
import IconOption from './IconOption.js';
import SubScreenSlide from './SubScreenSlide.js';
import HorizontalInputSlider from 'components/misc/horizontal_slider/HorizontalInputSlider.js';
import VerticalInputSlider from 'components/misc/vertical_slider/VerticalInputSlider.js';
import { setResolution, setLayout, setBorderWidth, setBackgroundColor, addTextBlock, setActiveEditScreen, shuffle } from 'components/collage/CollageSlice.js'
import { Scrollbars } from 'react-custom-scrollbars';
import EditBar from 'components/edit/EditBar.js';
import ColourPicker from 'components/misc/colour_picker/ColourPicker.js';

// Images
import RatioIcon from 'img/edit-icons/aspect-ratio.png';
import BorderIcon from 'img/edit-icons/borders.png';
import LayoutIcon from 'img/edit-icons/layout.png';
import TextIcon from 'img/edit-icons/text.png';
import ShuffleIcon from 'img/icons/shuffle.svg';
import PaletteIcon from 'img/edit-icons/palette.svg';
import Ratio1_1Icon from 'img/ratio-icons/ratio-1.1.png';
import Ratio1_2Icon from 'img/ratio-icons/ratio-1.2.png';
import Ratio2_1Icon from 'img/ratio-icons/ratio-2.1.png';
import Ratio3_4Icon from 'img/ratio-icons/ratio-3.4.png';
import Ratio4_3Icon from 'img/ratio-icons/ratio-4.3.png';
import Ratio4_5Icon from 'img/ratio-icons/ratio-4.5.png';
import Ratio5_4Icon from 'img/ratio-icons/ratio-5.4.png';
import Ratio5_7Icon from 'img/ratio-icons/ratio-5.7.png';
import Ratio7_5Icon from 'img/ratio-icons/ratio-7.5.png';
import Ratio9_16Icon from 'img/ratio-icons/ratio-9.16.png';
import Ratio16_9Icon from 'img/ratio-icons/ratio-16.9.png';
import GandrIcon from 'img/layout-icons/gandr-logo-v2.png';
import GridIcon from 'img/layout-icons/grid.png';
import BricksIcon from 'img/layout-icons/bricks.png';


// CSS
import './EditOptions.css';

class EditOptions extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // activeScreen: 'main',
      backgroundColorOpen: false,
      windowWidth: window.innerWidth
    }
  }

  componentDidMount() {
    window.addEventListener('resize', () => {
      this.setState({
        windowWidth: window.innerWidth
      });
    });
  }

  // componentDidUpdate() {

  // }

  // handleOptionClick = (screen) => {
  //   this.setState({
  //     activeScreen: screen,
  //     backgroundColorOpen: false
  //   })
  // }

  render() {

    let className = ['EditOptions', 'MainPadding'];

    if ( (this.props.collage.activeText !== false) ) {
      className.push('EditOptions--EditBarActive');
    }

    return (
      <div className={className.join(' ')}>
        <SubScreenSlide 
          active={this.props.collage.activeEditScreen == 'main'}
          backLink={false}
        >
          <nav>
            <ul>
              <li>
                <IconOption 
                  icon={RatioIcon}
                  title={'Ratio'}
                  description={'Change ratio of the collage'}
                  onClick={() => this.props.setActiveEditScreen('ratio')}
                />
              </li>
              <li>
                <IconOption 
                  icon={LayoutIcon}
                  title={'Layout'}
                  description={'Change layout of the photos in the collage'}
                  onClick={() => this.props.setActiveEditScreen('layout')}
                />
              </li>
              <li>
                <IconOption 
                  icon={BorderIcon}
                  title={'Border'}
                  description={'Adjust spacing between each photo in the collage'}
                  onClick={() => this.props.setActiveEditScreen('borders')}
                />
              </li>
              <li>
                <IconOption 
                  icon={PaletteIcon}
                  title={(this.props.collage.mode == 'sm' ? 'BG': 'Background')}
                  description={'Change the background color'}
                  onClick={() => this.setState({backgroundColorOpen: !this.state.backgroundColorOpen})}
                />
                {this.state.backgroundColorOpen &&
                  <div className="BackgroundColorPicker">
                    <ColourPicker 
                      colour={this.props.collage.backgroundColor}
                      onExit={() => this.setState({backgroundColorOpen: false})}
                      onPickColour={(colour) => {this.props.setBackgroundColor(colour)}}
                    />
                  </div>
                }
              </li>
              <li>
                <IconOption 
                  icon={TextIcon}
                  title={'Text'}
                  description={'Add text that overlays the collage'}
                  onClick={() => this.props.addTextBlock()}
                />
              </li>
              <li>
                <IconOption 
                  icon={ShuffleIcon}
                  title={'Shuffle'}
                  description={'Randomize the position and size of individual photos in the collage'}
                  onClick={() => this.props.shuffle()}
                />
              </li>
            </ul>
          </nav>
        </SubScreenSlide>
        <SubScreenSlide 
          active={this.props.collage.activeEditScreen == 'ratio'}
          backLink={true}
        >
          <nav>
            <Scrollbars style={{ width: '100%', height: '100%' }}>
              <ul>
                <li>
                  <IconOption 
                    icon={Ratio1_1Icon}
                    title={'1:1'}
                    onClick={() => this.props.setResolution({ratio: '1:1'})}
                    highlight={this.props.collage.resolution.ratio.name == '1:1'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio1_2Icon}
                    title={'1:2'}
                    onClick={() => this.props.setResolution({ratio: '1:2'})}
                    highlight={this.props.collage.resolution.ratio.name == '1:2'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio2_1Icon}
                    title={'2:1'}
                    onClick={() => this.props.setResolution({ratio: '2:1'})}
                    highlight={this.props.collage.resolution.ratio.name == '2:1'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio3_4Icon}
                    title={'3:4'}
                    onClick={() => this.props.setResolution({ratio: '3:4'})}
                    highlight={this.props.collage.resolution.ratio.name == '3:4'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio4_3Icon}
                    title={'4:3'}
                    onClick={() => this.props.setResolution({ratio: '4:3'})}
                    highlight={this.props.collage.resolution.ratio.name == '4:3'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio4_5Icon}
                    title={'4:5'}
                    onClick={() => this.props.setResolution({ratio: '4:5'})}
                    highlight={this.props.collage.resolution.ratio.name == '4:5'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio5_4Icon}
                    title={'5:4'}
                    onClick={() => this.props.setResolution({ratio: '5:4'})}
                    highlight={this.props.collage.resolution.ratio.name == '5:4'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio5_7Icon}
                    title={'5:7'}
                    onClick={() => this.props.setResolution({ratio: '5:7'})}
                    highlight={this.props.collage.resolution.ratio.name == '5:7'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio7_5Icon}
                    title={'7:5'}
                    onClick={() => this.props.setResolution({ratio: '7:5'})}
                    highlight={this.props.collage.resolution.ratio.name == '7:5'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio9_16Icon}
                    title={'9:16'}
                    onClick={() => this.props.setResolution({ratio: '9:16'})}
                    highlight={this.props.collage.resolution.ratio.name == '9:16'}
                  />
                </li>
                <li>
                  <IconOption 
                    icon={Ratio16_9Icon}
                    title={'16:9'}
                    onClick={() => this.props.setResolution({ratio: '16:9'})}
                    highlight={this.props.collage.resolution.ratio.name == '16:9'}
                  />
                </li>
              </ul>
            </Scrollbars>
          </nav>
        </SubScreenSlide>
        <SubScreenSlide 
          active={this.props.collage.activeEditScreen == 'layout'}
          backLink={true}
        >
          <nav>
            <ul>
              <li>
                <IconOption 
                  icon={GandrIcon}
                  title={'Gandr'}
                  onClick={() => this.props.setLayout('Gandr')}
                  highlight={this.props.collage.layout == 'Gandr'}
                />
              </li>
              <li>
                <IconOption 
                  icon={GridIcon}
                  title={'Grid'}
                  onClick={() => this.props.setLayout('Grid')}
                  highlight={this.props.collage.layout == 'Grid'}
                />
              </li>
              <li>
                <IconOption 
                  icon={BricksIcon}
                  title={'Brick Pattern'}
                  onClick={() => this.props.setLayout('Brick Pattern')}
                  highlight={this.props.collage.layout == 'Brick Pattern'}
                />
              </li>
            </ul>
          </nav>
        </SubScreenSlide>
        <SubScreenSlide 
          active={this.props.collage.activeEditScreen == 'borders'}
          backLink={true}
        >
          {/* <HorizontalInputSlider 
            onChange={(width) => this.props.setBorderWidth(width[0])}
          /> */}
          {this.state.windowWidth < 1024 &&
            <HorizontalInputSlider 
              onChange={(width) => this.props.setBorderWidth(width[0])}
            />
          }
          {this.state.windowWidth >= 1024 &&
            <VerticalInputSlider 
              onChange={(width) => this.props.setBorderWidth(width[0])}
            />
          }
        </SubScreenSlide>
        {(this.props.collage.activeText !== false && this.props.collage.mode == 'sm') &&
          <SubScreenSlide 
            active={this.props.collage.activeEditScreen == 'text_options'}
            backLink={false}
          >
            <EditBar />
          </SubScreenSlide>
        }
        
        {/* {(this.props.collage.activeText !== false) &&
          <EditBar />
        } */}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  { setResolution, setLayout, setBorderWidth, setBackgroundColor, addTextBlock, setActiveEditScreen, shuffle }
)(EditOptions)

